import React from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import PaymentIcon from '@mui/icons-material/Payment';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { useNavigate } from 'react-router-dom';

const UpdatePaymentBanner = props => {
  const { user }  = props;
  const navigate = useNavigate();
  if (!user?.patient) return null; // providers do not see this
  const shouldUpdatePayment = !user?.patient?.stax_customer_id;
  if (!shouldUpdatePayment) return null;
  return (
    <Alert severity='warning' icon={<PaymentIcon style={{marginTop: '0.25em'}}/>}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography>MovementX has updated our payment system — please take a quick moment to update your credit card information to keep your care running smoothly!</Typography>
        <Button 
          variant='contained' 
          color='primary'
          onClick={() => navigate('/clients/settings/payments')} style={{ marginLeft: 8 }}
        >
          Update
        </Button>
      </Stack>
    </Alert>
  );
}

export default UpdatePaymentBanner;